import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Affiche le commentaire d'un avis en respectant la langue courante.
 * - Si `comment_translations[lang]` existe et diffère de l'original, affiche
 *   la traduction + un bouton pour voir l'original.
 * - Sinon, affiche directement `comment`.
 *
 * Props :
 *   comment: string (texte source)
 *   translations: { fr?: string, en?: string }
 *   sourceLang: 'fr' | 'en' (langue d'origine du texte)
 */
export const ReviewComment = ({ comment, translations, sourceLang }) => {
  const { t, i18n } = useTranslation();
  const [showOriginal, setShowOriginal] = useState(false);

  const short = (i18n.language || 'fr').toLowerCase().split(/[-_]/)[0];
  const translated = translations && typeof translations === 'object' ? (translations[short] || '') : '';
  const src = (sourceLang || '').toLowerCase();

  // Pas de traduction utile si : (a) pas de traduction, (b) traduction = original,
  // (c) langue courante = langue source.
  const hasUsefulTranslation = Boolean(
    translated && translated.trim() && translated.trim() !== (comment || '').trim() && src && short !== src
  );

  const display = (!hasUsefulTranslation || showOriginal) ? (comment || '') : translated;

  return (
    <div>
      <p className="text-sm text-ink-light leading-relaxed whitespace-pre-wrap" data-testid="review-comment">
        {display}
      </p>
      {hasUsefulTranslation && (
        <button
          type="button"
          onClick={() => setShowOriginal((v) => !v)}
          className="mt-1 text-xs text-accent hover:underline"
          data-testid="review-toggle-original"
        >
          {showOriginal ? t('reviews.showTranslation', 'Voir la traduction') : t('reviews.showOriginal', "Voir l'avis original")}
        </button>
      )}
    </div>
  );
};

export default ReviewComment;
